<style lang="stylus" scoped>
.main
    // padding:30px
    .chesk-list
        font-size:16px;
        color:rgba(0,3,10,1);
        display:flex;
        border-bottom:1px solid rgba(7,19,54,0.05);
        .check
            margin-right:50px;
            cursor:pointer;
            padding:0 15px 10px;
        .active
            color:#F7AB3B;
            border-bottom:2px solid #F7AB3B;
    .table-list
        margin:20px 10px;
        .allnum
            border-bottom:1px solid #EEEEEE;
            margin-bottom:30px;
            padding-bottom:10px;
            .num-title
                color:#333333;
                font-size:16px;
                font-weight:bold;
            .num-list
                display:flex;
                align-items:center;
                margin-top:30px;
                .list-money
                    color:#FF3C6A;
                    font-size:38px;
                .list-name
                    color:#999999;
                    font-size:12px;
                    margin-left:20px;
                    margin-top:14px;
                .list-dedc
                    color:#FF3C6A;
                    font-size:12px;
                    margin-left:20px;
                    margin-top:14px;            
        .all-list
            .ivu-table
                .custom-table-row
                    font-size:12px
            td.red-column
                color:#f00 !important
            .list-title
                color:#333333
                font-size:16px
                margin-bottom:20px
            .no-pay
                text-align:center
        .bottom
            margin:45px 0px;
            text-align:center;
</style>
<template>
    <div class="main">
        <div class="chesk-list">
            <div class="check" :class="type == 'consult' ? 'active' : ''" @click="checktab('consult')">咨询账单</div>
            <div class="check" :class="type == 'post' ? 'active' : ''" @click="checktab('post')">知识账单</div>
        </div>
        <div v-if="type == 'consult'" class="table-list">
            <div v-if="!paymentData.length" class="all-list">
                <div class="list-title">账单</div>
                <div class="no-pay">
                    <img src="/static/img/no_pay.png">
                    <div>暂无账单记录！</div>
                </div>
            </div>
            <div v-else>
                <div class="allnum" v-if="is_lawyer">
                    <div class="num-title">我的账单</div>
                    <div class="num-list">
                        <div class="list-money">¥{{num}}</div>
                        <div class="list-name">总收入</div>
                        <div class="list-dedc">*暂未开通自主提现功能，请直接联系弘商管家提现</div>
                    </div>
                </div>
                <div class="all-list">
                    <div class="list-title">账单</div>
                    <Col span="24" class="main paymentmain">
                        <Table
                            :loading="tableLoading"
                            :columns="paymentColumns"
                            :data="paymentData"
                            :row-class-name="rowClassName"
                            no-data-text="暂无账单记录">
                        </Table>
                    </Col>
                </div>
            </div>
        </div>
        <div v-else-if="type == 'post'" class="table-list">
            <el-table style="min-width:1100px;width:100%;" :data="postlist" :header-cell-style="{background:'#FAFAFA',color:'rgba(0, 0, 0, 0.85)'}">
                <el-table-column prop="type" label="订单类型" width="120">
                    <template slot-scope="scoped">
                        <div style="color:#000000;">{{scoped.row.type | payType}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="about_name" label="订单名称"></el-table-column>
                <el-table-column prop="payer" label="支付者" width="100"></el-table-column>
                <el-table-column prop="order_no" label="订单号" width="230"></el-table-column>
                <el-table-column prop="pay_time" label="支付时间" width="170"></el-table-column>
                <el-table-column prop="pay_price" label="支付金额" width="100">
                    <template slot-scope="scoped">
                        <div style="color:red;">{{scoped.row.free_sign}} {{scoped.row.pay_price}}</div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="bottom" v-if="total > perpage">
                <el-pagination
                   background
                   :current-page.sync="page"
                   :page-size="perpage"
                   @current-change="handleCurrentChange"
                   layout="prev, pager, next, total"
                   :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'mybill',
    data() {
        return {
            type:'consult',
            tableLoading: false,
            paymentColumns:[],
            lawyer: [   //律师列表表头
                {
                    title: '收费项目',
                    key: 'type_title'
                },
                {
                    title: '支付方',
                    key: 'username'
                },
                {
                    title: '订单号',
                    key: 'order_sn',
                    width: 250
                },
                {
                    title: '支付时间',
                    key: 'pay_time',
                    width: 200
                },
                {
                    title: '金额(元)',
                    key: 'fee',
                    width:100,
                    className: 'red-column',
                    render: (h, params) => {            
                       return h('div',[
                          h('span', {
                             style: {
                                color: '#f00'
                              },

                          }, this.paymentData[params.index].fee),
                       ]); 
                    }
                }
            ],
            my: [  //普通用户列表表头
                {
                    title: '收费项目',
                    key: 'type_title'
                },
                {
                    title: '订单号',
                    key: 'order_sn',
                    width: 350
                },
                {
                    title: '支付时间',
                    key: 'pay_time',
                    width: 250
                },
                {
                    title: '金额(元)',
                    key: 'fee',
                    width:100,
                    className: 'red-column',
                    render: (h, params) => {            
                       return h('div',[
                          h('span', {
                             style: {
                                color: '#f00'
                              },

                          }, this.paymentData[params.index].fee),
                       ]); 
                    }
                }
            ],
            paymentData: [],
            is_lawyer:false,
            num:0,
            postlist:[],
            page:1,
            total:0,
            perpage: 5,
        }
    },
    mounted(){
        this.is_lawyer = this.$store.state.mineInfo.is_lawyer;
        if(this.is_lawyer){
            this.paymentColumns = this.lawyer;
        }else{
            this.paymentColumns = this.my;
        }
        this.getpaylist();
        this.getpostpsy();
    },
    methods: {
        checktab(index){
            this.type = index;
        },
        //获取订单列表
       getpaylist(){
           this.tableLoading = true;
           if(this.is_lawyer){
               var url = 'payment/lawyer';
           }else{
               var url = 'payment/my';
           };
           this.$ajax('get' , url  , res => {
                if (res.retcode === 0) {
                    this.paymentData = res.data;
                    var num = 0;
                    for (var i = 0; i < this.paymentData.length; i++) {
                      num = Number((num + Number(this.paymentData[i].fee)).toFixed(2));
                      this.paymentData[i].fee = this.paymentData[i].fee_sign + ' ' + this.paymentData[i].fee;
                    }
                    this.num = num;
                    this.tableLoading = false;
                } else {
                    this.tableLoading = false;
                  this.$message.error(res.data.errmsg)
                }
            })
       },
       //获取知识类订单列表
        getpostpsy(){
            let option = {
                page: this.page,
                per_page: this.perpage
            };
            this.$ajax('get', 'order/getList', option, res => {
                if(res.retcode === 0){
                    this.postlist = res.data;
                    this.total = res.total;
                };
            })
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getpostpsy();
        },
       //设置表格className
       rowClassName(row,index) {
            return 'custom-table-row';
        }, 
    },
    filters:{
        payType(type){
          if(type == 1){
              return '商事法律专栏';
          }else if(type == 2){
              return '知识';
          }else if(type == 3){
            return '课程课件';
          }
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/personalSetter/mybill.vue